<template>
  <v-container fluid>
    <v-card>
        <h1>NOSOTROS</h1>
    </v-card>
  </v-container>
</template>